import React from 'react';

import {
  useSkillsState,
  useSkillsActions,
} from './SkillsContext';

import {
  recognizeSkill,
  disallowSkill,
  associateSkillWithAuthenticatedUser,
  disassociateSkillWithAuthenticatedUser,
} from './restApi';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';

const SkillsTable = () => {
  const state = useSkillsState();
  const { onResponse, onError } = useSkillsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Claimed By You</Th>
          <Th>State</Th>
          <Th />
        </Tr>
      </Thead>
      <Tbody>
        {state?.skills?.map(skill => (
          <Tr key={skill.id}>
            <Td>{skill.name}</Td>
            <Td>{skill.claimedByAuthenticatedUser ? 'Yes' : 'No'}</Td>
            <Td>{skill.aasmState}</Td>
            <Td>
              <ActionRow align="end">
                {skill.claimedByAuthenticatedUser ? (
                  <Button
                    onClick={() => {
                      disassociateSkillWithAuthenticatedUser({
                        body: {
                          skillId: skill.id,
                          pageNumber: state?.pageNumber,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Unclaim
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      associateSkillWithAuthenticatedUser({
                        body: {
                          skillId: skill.id,
                          pageNumber: state?.pageNumber,
                          authenticityToken,
                        },
                        onResponse,
                        onError,
                      });
                    }}
                  >
                    Claim
                  </Button>
                )}
                {state?.authenticatedUser?.canAdministerSkills && (
                  <>
                    <Button
                      onClick={() => {
                        recognizeSkill({
                          onResponse,
                          onError,
                          body: {
                            skillId: skill.id,
                            pageNumber: state?.pageNumber,
                            authenticityToken,
                          },
                        });
                      }}
                    >
                      Recognize
                    </Button>
                    <Button
                      onClick={() => {
                        disallowSkill({
                          onResponse,
                          onError,
                          body: {
                            skillId: skill.id,
                            pageNumber: state?.pageNumber,
                            authenticityToken,
                          },
                        });
                      }}
                    >
                      Disallow
                    </Button>
                  </>
                )}
              </ActionRow>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default SkillsTable;
